import { render, staticRenderFns } from "./CreateFeeModal.vue?vue&type=template&id=31022a81&scoped=true&"
import script from "./CreateFeeModal.vue?vue&type=script&lang=js&"
export * from "./CreateFeeModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateFeeModal.vue?vue&type=style&index=0&id=31022a81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31022a81",
  null
  
)

export default component.exports